"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AddonManager = (function () {
    function AddonManager(player) {
        this.player = player;
        this.addons = new Array();
    }
    AddonManager.prototype.setAddons = function () {
        var _this = this;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        params.forEach(function (addon) {
            if (addon) {
                _this.addons.push(addon);
            }
        });
    };
    AddonManager.prototype.sessionWillStart = function (playoutRequestData) {
        var _this = this;
        this.currentSession = { addons: new Array(), started: new Date() };
        if (!this.addons.length) {
            return Promise.resolve(this.currentSession);
        }
        var promises = this.addons.map(function (addon) {
            return addon
                .sessionWillStart(playoutRequestData)
                .then(function (shouldUseAddon) {
                if (shouldUseAddon) {
                    _this.currentSession.addons.push(addon);
                }
            })
                .catch(function (errorMessage) {
                var error = {
                    code: addon.name + "-COULD_NOT_START_SESSION",
                    message: errorMessage,
                    isFatal: true,
                };
                return Promise.reject(error);
            });
        });
        return Promise.all(promises).then(function () { return _this.currentSession; });
    };
    AddonManager.prototype.sessionDidStart = function (playoutRequestData) {
        var _this = this;
        var addonLoadPromiseChain = Promise.resolve(playoutRequestData);
        this.currentSession.addons.forEach(function (addon) {
            addonLoadPromiseChain = addonLoadPromiseChain.then(function (newPlayoutRequestData) {
                return addon.sessionDidStart(_this.player, newPlayoutRequestData).catch(function () { return newPlayoutRequestData; });
            });
        });
        return addonLoadPromiseChain;
    };
    AddonManager.prototype.nativePlayerWillLoad = function (nativeLoadData, playoutRequestData) {
        var playerWillLoad = true;
        if (!this.currentSession) {
            return playerWillLoad;
        }
        this.currentSession.addons.forEach(function (addon) {
            var result = addon.nativePlayerWillLoad(nativeLoadData, playoutRequestData);
            if (!result) {
                playerWillLoad = false;
            }
        });
        return playerWillLoad;
    };
    AddonManager.prototype.nativePlayerDidLoad = function (nativeLoadData, playoutRequestData) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerDidLoad(nativeLoadData, playoutRequestData); });
    };
    AddonManager.prototype.nativePlayerWillPlay = function () {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerWillPlay(); });
    };
    AddonManager.prototype.nativePlayerWillPause = function () {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerWillPause(); });
    };
    AddonManager.prototype.nativePlayerWillStop = function (reason) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerWillStop(reason); });
    };
    AddonManager.prototype.nativePlayerWillSeek = function (position) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerWillSeek(position); });
    };
    AddonManager.prototype.nativePlayerDidSeek = function () {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerDidSeek(); });
    };
    AddonManager.prototype.nativePlayerWillSetAudioTrack = function (track) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.nativePlayerWillSetAudioTrack(track); });
    };
    AddonManager.prototype.nativePlayerDidError = function (playerError) {
        if (!this.currentSession) {
            return playerError;
        }
        this.currentSession.addons.forEach(function (addon) {
            playerError = addon.nativePlayerDidError(playerError);
        });
        return playerError;
    };
    AddonManager.prototype.shouldSessionEnd = function (reason) {
        if (!this.currentSession) {
            return true;
        }
        return this.currentSession.addons.reduce(function (acc, addon) { return acc && addon.shouldSessionEnd(reason); }, true);
    };
    AddonManager.prototype.sessionWillEnd = function (reason) {
        if (!this.currentSession) {
            return Promise.resolve([]);
        }
        return Promise.all(this.currentSession.addons.map(function (addon) { return addon.sessionWillEnd(reason); }));
    };
    AddonManager.prototype.sessionDidEnd = function (reason) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) { return addon.sessionDidEnd(reason); });
        this.currentSession = null;
    };
    AddonManager.prototype.skipCurrentAdBreak = function () {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) {
            addon.skipCurrentAdBreak();
        });
    };
    AddonManager.prototype.updateAdProfileLimits = function (adProfileLimits) {
        if (!this.currentSession) {
            return;
        }
        this.currentSession.addons.forEach(function (addon) {
            addon.updateAdProfileLimits(adProfileLimits);
        });
    };
    return AddonManager;
}());
exports.AddonManager = AddonManager;
